import React, { useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectLocaleDict } from 'features/locale/selectors'

import Button from 'components/UIKit/Button/Button'

import bg from './img/bg.webp'
import { ReactComponent as LogoSVG } from './img/notify-logo.svg'

import './NotifyContainer.scss'

interface INotifyContainerProps {
  title: string
  value: string
  currency: string
  callback: () => void
  hideTemporarily: () => void
}

const b = block('notify-container')

const NotifyContainer: React.FC<INotifyContainerProps> = ({ title, value, callback, hideTemporarily, currency }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  return (
    <div className={b()}>
      <div className={b('background')} onClick={hideTemporarily} />
      <div className={b('container')}>
        <div className={b('heading')}>
          <span className={b('title')}>{title.toUpperCase()}</span>
        </div>
        <div className={b('content')}>
          <div className={b('you-got')}>{locale.youGot}</div>
          <div className={b('value-wrapper')}>
            <div className={b('value')}>{value}</div>
            <div className={b('currency')}>{currency}</div>
          </div>
          <div className={b('button-wrapper')}>
            <Button text={locale.thankYou} callback={callback} colorType="main" />
          </div>
        </div>

        <div className={b('divider')} />
        <div className={b('logo-wrapper')}>
          <LogoSVG className={b('logo')} />
        </div>
      </div>
    </div>
  )
}

export default NotifyContainer
